// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1l7Gm","author":"Table_author__398vS","authorImage":"Table_authorImage__2MB-s","unreadRow":"Table_unreadRow__1uT9e"};